import { environment } from 'src/environments/environment';
import { PaletteDetailModel } from '../models/palettes/palette_detail_model';

export const SUBSCRIPTIONS = [
  {
    item_id: environment.stripeKey.startsWith('pk_live_')
      ? 'price_1IeZoRBjrdGenLaHkb0Rg9Rl'
      : 'price_1IeZf3BjrdGenLaH3SGtHuiq',
    item_name: 'Monthly',
    currency: 'USD',
    index: 0,
    price: 5.0,
    quantity: 1,
  },
  {
    item_id: environment.stripeKey.startsWith('pk_live_')
      ? 'price_1IeZoQBjrdGenLaHA2EU3lTk'
      : 'price_1IeZf3BjrdGenLaHNWCzpoU5',
    item_name: 'Yearly',
    currency: 'USD',
    index: 0,
    price: 50.0,
    quantity: 1,
  },
];

export enum LocalStorageKeys {
  AuthProvider = 'auth_provider',
  // Legacy tour key (deprecated - kept for backwards compatibility)
  StartWelcomeTour = 'start_tour',
  // Legacy hint keys (deprecated)
  HintUploadImage = 'hint-upload-image',
  HintMoveAndScaleImage = 'hint-move-and-scale-image',
  HintTransferImage = 'hint-transfer-image',
  // New onboarding keys
  OnboardingWelcomeCompleted = 'onboarding_welcome_completed',
  OnboardingPath = 'onboarding_path',
  OnboardingChecklistState = 'onboarding_checklist_state',
  OnboardingChecklistCompleted = 'onboarding_checklist_completed',
  OnboardingTutorialCompleted = 'onboarding_tutorial_completed',
  PatternSetupPrompted = 'pattern_setup_prompted',
  // New directive hint keys
  HintUploadCompleted = 'hint_upload_completed',
  HintMoveScaleCompleted = 'hint_move_scale_completed',
  HintTransferredCompleted = 'hint_transferred_completed',
  HintPickColorCompleted = 'hint_pick_color_completed',
  HintPlaceBeadCompleted = 'hint_place_bead_completed',
  HintFillToolCompleted = 'hint_fill_tool_completed',
  HintSaveReminderShown = 'hint_save_reminder_shown',
}

export enum HintSteps {
  UploadImage = 0,
  TransferImage = 1,
  MoveAndScaleImage = 2,
}

export const DEFAULT_ZOOM_FACTOR = 0.35;

export const EMPTY_BEAD: PaletteDetailModel = <PaletteDetailModel>{
  paletteId: -1,
  paletteDetailId: -1,
  paletteBeadId: -1,
  name: 'empty',
  description: '',
  paletteTypeId: 0,
  color: '000000',
  count: 0,
};
